import { useRooms } from "../../contexts/RoomsProvider";

import "./TopBar.css";
import Logo from "../Logo/Logo";

export default function TopBar() {
  const { getRoomsData } = useRooms();

  const roomData = getRoomsData();

  return (
    <div className="top-bar">
      <Logo />
      {roomData && (
        <span className="room-data">Your group: {roomData.cohort}</span>
      )}
    </div>
  );
}
